import { Accordion, Icon, Label, Table, Message } from 'semantic-ui-react';
import type { PersonListDto } from '@app/api2/api';

interface Props {
  results: PersonListDto[];
  activeIndex: number;
  onAccordionClick: (index: number) => void;
}

export const SearchResults: React.FC<Props> = ({ results, activeIndex, onAccordionClick }) => {
  return (
    <>
      {results.length > 20 && (
        <Message info>
          <Message.Header>Large Result Set</Message.Header>
          <p>Your search returned {results.length} results. Showing the first 20 matches.</p>
        </Message>
      )}
      <Accordion fluid styled>
        {results.slice(0, 20).map((result, index) => (
          <div key={result.id}>
            <Accordion.Title
              active={activeIndex === index}
              index={index}
              onClick={() => onAccordionClick(index)}
            >
              <Icon name="dropdown" />
              <strong>{result.firstName || 'Unknown'} {result.lastName || 'Unknown'}</strong>
              {' - '}
              <Label size="small" color="teal">{result.enrollmentPurpose}</Label>
              {' - '}
              <small>ID: {result.id}</small>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === index}>
              <Table definition>
                <Table.Body>
                  {Object.entries(result).map(([key, value]) => {
                    if (key === 'parsedLociData' || key === 'createdAt') return null;
                    if (value === null || value === undefined || value === '') return null;
                    const displayKey = key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()).trim();
                    return (
                      <Table.Row key={key}>
                        <Table.Cell width={4}>{displayKey}</Table.Cell>
                        <Table.Cell>{String(value)}</Table.Cell>
                      </Table.Row>
                    );
                  })}
                  <Table.Row>
                    <Table.Cell>Created</Table.Cell>
                    <Table.Cell>
                      {new Date(result.createdAt).toLocaleDateString()} {new Date(result.createdAt).toLocaleTimeString()}
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Accordion.Content>
          </div>
        ))}
      </Accordion>
    </>
  );
};